import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

/**
 * Safely parses HTML string into React elements
 * @param {string} htmlString - The HTML string to parse
 * @returns {React.ReactNode} - Parsed React elements
 */
export const safeHtmlParser = (htmlString) => {
  if (!htmlString) {
    return null;
  }
  return parse(DOMPurify.sanitize(htmlString));
};

/**
 * Safely parses HTML string into React elements with custom options
 * @param {string} htmlString - The HTML string to parse
 * @param {Object} options - Options for DOMPurify sanitization
 * @returns {React.ReactNode} - Parsed React elements
 */
export const safeHtmlParserWithOptions = (htmlString, options = {}) => {
  if (!htmlString) {
    return null;
  }
  return parse(DOMPurify.sanitize(htmlString, options));
};